<template>
    <div id="login-new">
        <div id="app">
            <div v-if="!isInitComplete" class="loading-full-page">
                <span />
                <span />
                <span />
            </div>
            <section class="login-screen">
                <div class="form-login form-login-nonmembers">
                    <ValidationObserver ref="observer" v-slot="{ invalid }" tag="form">

                        <h1 class="login-logo"><img class="img" src="/assets/img/common/logo.svg" alt="アドフープ" width="209"/></h1>
                        <div class="login-header">
                            <div style="margin-bottom:30px;">
                                <h2 class="login-header-title">新規会員登録</h2>
                                <p>本サービスは法人のお客様を対象としております。</p>
                                <p>パートナー加盟ご希望の方は、<a href="https://go.ad-hoop.net/adhoop/agency/" target="_blank">こちら</a>からお願いします。</p>
                            </div>
                        </div>
                        <div class="login-body">
                            <!-- 会社名 -->
                            <div class="login-body-group">
                                <ValidationProvider name="会社名" rules="required|max:100" v-slot="{ errors }">
                                    <p class="login-text">会社名
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <input class="js-validate js-required" type="account_name" name="account_name" v-model="account_name" placeholder="株式会社〇〇〇〇" />
                                    </label>
                                </ValidationProvider>
                            </div>
                            <!-- 担当者名 -->
                            <div class="login-body-group">
                                <ValidationProvider name="担当者名" rules="required|max:100" v-slot="{ errors }">
                                    <p class="login-text">担当者名
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <input class="js-validate js-required" type="pic_name" name="pic_name" v-model="pic_name" placeholder="山田 太郎" />
                                    </label>
                                </ValidationProvider>
                            </div>
                            <!-- 部署名 -->
                            <div class="login-body-group">
                                <ValidationProvider name="部署名" rules="required|max:100" v-slot="{ errors }">
                                    <p class="login-text">部署名
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <input class="js-validate js-required" type="pic_department_name" name="pic_department_name" v-model="pic_department_name" placeholder="マーケティング部" />
                                    </label>
                                </ValidationProvider>
                            </div>
                            <!-- 役職 -->
                            <div class="login-body-group">
                                <ValidationProvider name="役職" rules="required" v-slot="{ errors }">
                                    <p class="login-text">役職
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <AdHoopCustomSelect v-model="pic_position_id" :options="profilePicPositionOptions" />
                                    </label>
                                </ValidationProvider>
                            </div>
                            <!-- メールアドレス -->
                            <div class="login-body-group">
                                <ValidationProvider name="メールアドレス" rules="required|email|max:100" v-slot="{ errors }">
                                    <p class="login-text">メールアドレス
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <input class="input" :class="{ 'validate_error': validate('mail_address'), 'error': errors[0] }" type="text" @input="inputMailAddress('mail_address')"  name="mail_address" v-model="mail_address" placeholder="example@abc.co.jp" />
                                    </label>
                                    <span v-if="validate('mail_address')" class="form-error">{{ validate('mail_address') }}</span>
                                    <p class="login-text detail-text">
                                        フリーメール、プロバイダーメールはご登録いただけません。
                                    </p>
                                </ValidationProvider>
                            </div>
                            <!-- 電話番号 -->
                            <div class="login-body-group">
                                <ValidationProvider name="電話番号" rules="required|max:100" v-slot="{ errors }">
                                    <p class="login-text">電話番号
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <label class="login-input">
                                        <input class="js-validate js-required" type="phone_number" name="phone_number" v-model="phone_number" placeholder="090-1234-5678" />
                                    </label>
                                    <p class="login-text detail-text">※携帯電話、固定電話どちらでも登録可能です。</p>
                                </ValidationProvider>
                            </div>
                            <!-- 業界/業種 -->
                            <div class="login-body-group">
                                <ValidationProvider name="業界/業種" rules="required" v-slot="{ errors }">
                                    <p class="login-text">業界/業種
                                        <span class="form-error">{{ errors[0] }}</span>
                                    </p>
                                    <div class="form-detail annual-sales">
                                        <div class="form-detail_horizontal">
                                            <AdHoopCustomSelect name="industry-select" v-model="selected_industries" :options="industryOptions" @input="onInputIndustries(selected_industries)"/>
                                            <AdHoopCustomSelect name="industryMedium-select" v-model="selected_industries_medium" :options="industryMediumOptions" />
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <!-- 同意用チェックボックス -->
                        <div class="login-body-group login-center">
                            <ValidationProvider tag="div" class="login-body-group" name="同意用チェックボックス" rules="required" v-slot="{ errors }">
                                <div class="icn-checkbox">
                                    <label>
                                        <input :class="{'error': errors != ''}" type="checkbox" name="consent_checkbox" v-model="consent_checkbox"/>
                                        <span></span>
                                    </label>
                                </div>
                                <a class="terms" href="https://support.ad-hoop.net/terms/client_terms.pdf?20250401" target="_blank">利用規約</a>および<a class="policy" href="https://www.yrglm.co.jp/policy/privacy_f/" target="_blank" rel="noopener noreferrer">個人情報の取扱いについて</a>に同意する
                                <span class="form-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <!-- アカウントコード生成失敗 -->
                        <template v-if="sys_err">
                            <div>
                                <span class="form-error"><br>アカウントコードの生成に失敗しました<br>恐れ入りますがシステム管理者までご連絡ください。</span>
                            </div>
                            <div class="login-body-link">
                                <a>support@ad-hoop.net</a>
                            </div>
                            <span>&nbsp;</span>
                        </template>
                        <br />
                        <!-- 登録ボタン -->
                        <div class="login-btn">
                            <button class="btn-submit trans" type="button" @click="register">無料登録</button>
                        </div>
                        <br />
                        <p class="login-body-note">
                            既に会員の方は
                            <a class="terms" href="/" target="" style="text-align:center;">こちら</a>
                        </p>
                    </ValidationObserver>
                </div>
                <div class="login-copyright">
                    <p class="copy">Copyright © YRGLM Inc. All Rights Reserved.</p>
                    <a class="policy" href="https://www.yrglm.co.jp/policy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
                    <a class="policy" href="https://support.ad-hoop.net/terms/client_terms.pdf?20250401" target="_blank">利用規約</a>
                    <a class="terms" href="https://support.ad-hoop.net/terms/client_review_terms.pdf?20240820" target="_blank">レビュー規約</a>
                </div>
            </section>

            <!-- エラー通知用モーダル -->
            <Error ref="errorModal" />

            <!-- レビュー投稿フローティングバナー -->
            <template v-if="floating">
                <div id="floating-banner" >
                    <span id="close-btn" @click="clickFloatingClose()">&times;</span>
                    <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdpWvByvlpL1YY0wYCgmtg9XMpzEfiJjJcw8Kp1qSOWazqEDQ/viewform">
                        <img src="/assets/img/common/r_banner3000.png" alt="レビュー投稿促進バナー">
                    </a>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
import * as rules from 'vee-validate/dist/rules'
import AdHoopCustomSelect from '../../components/input/AdHoopCustomSelect'

for (let rule in rules) {
    extend(rule, rules[rule])
}

// todo: 行儀の悪いコードになってしまった
ja.messages.regex = '{_field_}は[英字][数字][記号(-!#$%&/?@_,.:;)]をそれぞれ1文字以上含めてください'

localize('ja', ja)

export default {
    name: 'App',
    components: {
        ValidationProvider,
        ValidationObserver,
        AdHoopCustomSelect,
    },
    data() {
        return {
            // フローティングバナー表示判定
            floating: true, 
            readyToValidate: false,
            account_name: '',
            pic_name: '',
            pic_department_name: '',
            pic_position: '',
            pic_position_id: '',
            mail_address: '',
            phone_number: '',
            selected_industries: '',
            selected_industries_medium: '',
            consent_checkbox: false,
            isInitComplete: true,
            sys_err: '',
            // 業界・業種マスタ
            industryOptions: [],
            // 業界・業種マスタ（中カテゴリ）
            industryMediumOptionsAll: {},
            industryMediumOptions: [],
            // 無効ドメインマスタ
            invalidDomain: null,
            // プロフィール役職マスタ
            profilePicPositionOptions: [],
        }
    },
    async created() {
        this.setTitle('会員登録')
        this.account_code = this.$route.query.a
        this.reset_token = this.$route.query.reset_token
        // 業界・業種マスタ初期化
        this.industryOptions.splice(0, this.industryOptions.length)
        // 業界・業種マスタ取得
        this.industryOptions = await this.$api.ad_match.getAdMatchIndustries_no_auth()
        // 業界・業種マスタ（中カテゴリ）初期化
        Object.keys(this.industryMediumOptionsAll).forEach(key => {
            this.$delete(this.industryMediumOptionsAll, key)
        })
        // 業界・業種マスタ（中カテゴリ）取得
        let ret = await this.$api.ad_match.getAdMatchIndustriesMedium_no_auth()
        // 中マスタを親id単位でオブジェクト配列化
        for (var i = 0; i < this.industryOptions.length; i++) {
            this.$set(this.industryMediumOptionsAll, this.industryOptions[i].id, ret.filter(item => item.parent_industry_id === this.industryOptions[i].id));
        }
        this.industryMediumOptions = this.industryMediumOptionsAll[this.selected_industries]
        // 無効ドメインマスタ取得
        this.invalidDomain = await this.$api.ad_match.getAdMatchInvalidDomain_no_auth()
        // プロフィール役職マスタ取得
        this.profilePicPositionOptions = await this.$api.ad_match.getAdMatchProfilePicPosition_no_auth()
        this.isInitComplete = true
    },

    methods: {
        // 会員登録処理
        async register() {
            // 入力チェックを同期で実行
            this.readyToValidate = true
            if (!(await this.$refs.observer.validate()) || this.validate()) {
                return
            }
            // 事業者登録
            var params;
            params = {
                account_name: this.account_name, 
                pic_name: this.pic_name, 
                pic_department_name: this.pic_department_name, 
                pic_position_id: this.pic_position_id, 
                mail_address: this.mail_address, 
                phone_number: this.phone_number, 
                selected_industries: this.selected_industries, 
                selected_industries_medium: this.selected_industries_medium, 
                consent_checkbox: this.consent_checkbox, 
            }
            let res = await this.$api.common.registerAccounts(params)
            if (res.error) {
                if(res.sys_err) {
                    this.sys_err = true
                }
                this.$refs.observer.setErrors(res.messages)
                return
            }
            // メール送信画面へ飛ばす
            this.loadPage(this.frontend_url + 'complete_register')
        },
        // 業界/業種プルダウン選択
        onInputIndustries(parents_id) {
            this.industryMediumOptions = this.industryMediumOptionsAll[parents_id]
            this.selected_industries_medium = this.industryMediumOptions[0].id
        },
        // メールアドレス変更処理
        inputMailAddress() {
            this.readyToValidate = true
            this.validate('mail_address')
        },
        // 独自バリデーション
        validate(name = null) {
            if (!this.readyToValidate) {
                return false
            }
            // 個別に入力チェックを実装する場合はここに記載
            // メールアドレスのチェック
            if (name == 'mail_address' || name == null) {
                // 半角文字チェック
                if(!(/^[\x20-\x7e]*$/.test(this.mail_address))) {
                    return '半角文字で入力してください'
                }
                // ドメインチェック
                for(let row of this.invalidDomain) {
                    if(this.mail_address.includes(row.domain)) {
                        return row.domain + 'のアドレスは登録できません'
                    }
                }
            }
            return false
        },
        // フローティングバナー閉じる
        clickFloatingClose() {
            this.floating = false
        },
    },
}
</script>

<style>
.form-login .login-body-group + .login-body-group {
    margin-top: 20px;
}
</style>
